import showdown from 'devextreme-showdown'

const converter = new showdown.Converter()

export function parseMarkdownContent (content: string): string {
  return converter.makeHtml(content)
}
